import { render } from "./index.vue?vue&type=template&id=4477d546&scoped=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=4477d546&lang=less&scoped=true"
script.render = render
script.__scopeId = "data-v-4477d546"

export default script